module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-analytic-3.429504ac.svg";